<template>
    <v-dialog
    v-model="show"
    persistent
    width="480">
   
    <v-card color="light_gray">
        <v-toolbar class="mid-font" dense >
            <v-icon left >mdi-cog</v-icon><span class="va-underline"> Sales ID: {{sales.id}}</span>
            <v-spacer/>
            <!-- <v-icon  @click="emitToParent('close')">mdi-close</v-icon> -->
          </v-toolbar>
          <v-card-text class="pa-4 def-font text-center">
  
                    <p class="text-h3 font-weight-bold ma-0">{{$money(sales.total_amount)}}</p>    
                    <span class="text-info">Total Amount</span>
                <v-divider class="mt-4 mb-4"/>
                    <template v-if="sales.type=='Job Order'">
                        <p class="text-center">Select Current Job Order Status</p>
                    </template>
                    <p v-if="sales.type=='Job Order'">
                     <v-btn  large color="secondary" 
                     @click="job_remarks='Ready for scheduling',log.message='Job order has been created and is ready for scheduling', UpdateLog()" 
                     block>
                      Ready for scheduling </v-btn>
                    </p>
                    <p v-else>
                      
                      <v-btn  large color="secondary" 
                     @click="sales.payment_status='Completed',sales.remarks='Completed', sales.payment_status='Paid', UpdatePayment()" 
                     block>
                      Confirm Payment</v-btn>
                      </p>
                     
          </v-card-text>
          <v-card-actions>
               
            
              
          </v-card-actions>
    </v-card>
  
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show:{
          type: Boolean,
          default: false
      },
      state: {
          type: String,
          default: 'new'
      },
      sales: {
          type: Object,
          default: ()=>{}
      },

  },
  data () {
      return {
        valid: true,
        log:{message:"", timestamp:"", user:0},
        job_remarks:""
      }
    },
//   watch: {
    
//   },
  computed:{
    
  },
  methods: {
   emitToParent () {
      this.$emit('DialogEvent', this.sales.id)
    },
    UpdateLog(){
        var service_logs = []
        this.log.timestamp =  this.$moment().format("YYYY-MM-DD hh:mm A")
        this.log.user =  this.$session.get('fullname')
        
        if(this.sales.service_logs == null || this.sales.service_logs == "" || this.sales.service_logs == undefined) {
            service_logs.push(this.log)
            this.sales.service_logs = service_logs
        } else {
            this.sales.service_logs.push(this.log)
        }

            let params = {
            table: "product_items", 
            type:"update",
            query:`update sales set  remarks='${this.job_remarks}', service_logs='${JSON.stringify(this.sales.service_logs)}' where id=${this.sales.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
            this.emitToParent()
        }).catch(e => {
          console.log(e.data)
        })
    },
    UpdatePayment(){
       
            let params = {
            table: "product_items", 
            type:"update",
            query:`update sales set status='Completed', payment_status='${this.sales.payment_status}' where id=${this.sales.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
            this.emitToParent()
        }).catch(e => {
          console.log(e.data)
        })
    }
  }
}
</script>
